import React from 'react';
import { motion } from 'framer-motion';
export function Header() {
  return <motion.header initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} className="w-full py-8 px-6 flex flex-col items-center justify-center relative z-10" data-id="element-32">
      <div className="text-red font-script text-xl md:text-2xl mb-1 transform -rotate-2" data-id="element-33">
        Coming Soon
      </div>
      <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl tracking-wide text-cream uppercase" data-id="element-34">
        Depinga Café
      </h1>
      <div className="mt-2 flex items-center gap-4" data-id="element-35">
        <div className="h-px w-8 bg-pale/40" data-id="element-36"></div>
        <span className="text-pale text-xs tracking-[0.2em] font-sans uppercase" data-id="element-37">
          Est. 2026
        </span>
        <div className="h-px w-8 bg-pale/40" data-id="element-38"></div>
      </div>
    </motion.header>;
}